import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/xcode.css"; // pick a theme for code snippets
// themes can be demonstrated here: https://highlightjs.org/demo
import 'react-markdown-code-highlighter/style.css';
import BotBubble from './BotBubble';
import { normalizeMarkdown } from '../util/normalizeMarkdown';
import ESBotAvatar from "./ESBotAvatar";

const MarkdownWidget = ({ payload }) => {
    // const { message } = props;
    // console.log("I was hereeee!!!!!!");
    // console.log("the messageData is!!--", payload);

    return (
        <div className="flex items-start space-x-3">
            <ESBotAvatar />
            <BotBubble>
                <div className="markdown-widget">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}
                        rehypePlugins={[rehypeHighlight]}
                    >
                        {normalizeMarkdown(payload)}
                    </ReactMarkdown>
                </div>
            </BotBubble>
        </div>
    );
};

export default MarkdownWidget;